import { call, put, take, select } from 'redux-saga/effects';
import { push } from 'connected-react-router';
import * as types from 'src/state/ducks/shop/types';
import * as actions from 'src/state/ducks/shop/actions';
import * as api from 'src/state/ducks/shop/api';
import { Status } from 'src/constants/Interface';

const selectAdminState = (state: any) => state.admin;

function* dispatchGetShops() {
  while (true) {
    yield take(types.GET_SHOPS);
    try {
      const res = yield call(api.getShops);
      if (res.status === Status.SUCCESS) {
        yield put(actions.successGetShops(res));
      } else if (res.status === Status.INVALID) {
        yield put(actions.failGetShops(res));
      }
    } catch (err) {
      throw err;
    }
  }
}

function* dispatchCreateShop() {
  while (true) {
    const action = yield take(types.CREATE_SHOP);
    try {
      const res = yield call(api.createShop, action.payload);
      if (res.status === Status.SUCCESS) {
        yield put(actions.successCreateShop(res));
        console.log('SHOP CREATE');
        yield put(push('/'));
      } else if (res.status === Status.INVALID) {
        yield put(actions.failCreateShop(res));
      }
    } catch (err) {
      yield put(
        actions.failCreateShop({
          status: Status.FAILURE,
          error: {
            code: err.code | 500,
            message: err.message,
          },
        }),
      );
    }
  }
}

function* dispatchUpdateShop() {
  while (true) {
    const action = yield take(types.UPDATE_SHOP);
    try {
      const res = yield call(api.updateShop, action.payload);
      const state = yield select(selectAdminState);
      const { login_shop_id } = state;
      if (res.status === Status.SUCCESS) {
        yield put(actions.successUpdateShop(res));
        const path = login_shop_id ? `/shop/${login_shop_id}/edit/complete` : '/shop/complete';
        yield put(push(path));
      } else if (res.status === Status.INVALID) {
        yield put(actions.failUpdateShop(res));
      }
    } catch (err) {
      console.error(err);
      yield put(
        actions.failUpdateShop({
          status: Status.FAILURE,
          error: {
            code: err.code | 500,
            message: err.message,
          },
        }),
      );
    }
  }
}

function* dispatchUpdateShopBags() {
  while (true) {
    const action = yield take(types.UPDATE_SHOP_BAGS);
    try {
      const { id, query } = action.payload;
      const res = yield call(api.updateShopBags, id, query);
      if (res.status === Status.SUCCESS) {
        yield put(actions.successUpdateShopBags(res));
        yield put(push(`/shop/bags/complete`));
      } else if (res.status === Status.INVALID) {
        yield put(actions.failUpdateShopBags(res));
      }
    } catch (err) {
      console.error(err);
      yield put(
        actions.failUpdateShopBags({
          status: Status.FAILURE,
          error: {
            code: err.code | 500,
            message: err.message,
          },
        }),
      );
    }
  }
}

function* dispatchCreateShopMenu() {
  while (true) {
    const action = yield take(types.CREATE_SHOP_MENU);
    try {
      const { doc_id, query } = action.payload;
      const res = yield call(api.createShopMenu, doc_id, query);
      const state = yield select(selectAdminState);
      const { login_shop_id } = state;
      if (res.status === Status.SUCCESS) {
        yield put(actions.successCreateShopMenu(res));
        yield put(push(`/shop/${login_shop_id}/menu/complete`));
      } else if (res.status === Status.INVALID) {
        yield put(actions.failCreateShopMenu(res));
      }
    } catch (err) {
      throw err;
    }
  }
}

function* dispatchEditShopMenu() {
  while (true) {
    const action = yield take(types.EDIT_SHOP_MENU);
    try {
      const { doc_id, menu_id, query } = action.payload;
      const res = yield call(api.updateShopMenu, doc_id, menu_id, query);
      const state = yield select(selectAdminState);
      const { login_shop_id } = state;
      if (res.status === Status.SUCCESS) {
        yield put(actions.successEditShopMenu(res));
        yield put(
          push({
            pathname: `/shop/${login_shop_id}/menu/complete`,
            state: { method: 'UPDATE' },
          }),
        );
      } else if (res.status === Status.INVALID) {
        yield put(actions.failEditShopMenu(res));
      }
    } catch (err) {
      yield put(
        actions.failEditShopMenu({
          status: Status.FAILURE,
          error: {
            code: err.code | 500,
            message: err.message,
          },
        }),
      );
    }
  }
}

function* dispatchGetShop() {
  while (true) {
    const { payload } = yield take(types.GET_SHOP);
    try {
      const res = yield call(api.getShop, payload);
      if (res.status === Status.SUCCESS) {
        yield put(actions.successGetShop(res));
      }
    } catch (err) {
      yield put(
        actions.failGetShop({
          status: Status.FAILURE,
          error: {
            code: err.code | 500,
            message: err.message,
          },
        }),
      );
    }
  }
}

function* dispatchUpdateMailSenders() {
  while (true) {
    const action = yield take(types.UPDATE_MAIL_SENDERS);
    const { doc_id, method, address } = action.payload;
    try {
      let res;
      if (method === 'add') {
        res = yield call(api.addMailSenders, doc_id, address);
      } else {
        res = yield call(api.deleteMailSenders, doc_id, address);
      }
      if (res.status === Status.SUCCESS) {
        yield put(actions.successUpdateMailSenders(res));
      } else if (res.status === Status.INVALID) {
        yield put(actions.failUpdateMailSenders(res));
      }
    } catch (err) {
      yield put(
        actions.failUpdateMailSenders({
          status: Status.FAILURE,
          error: {
            code: err.code | 500,
            message: err.message,
          },
        }),
      );
    }
  }
}

const adminSagas = [
  dispatchGetShops(),
  dispatchCreateShop(),
  dispatchUpdateShop(),
  dispatchUpdateShopBags(),
  dispatchCreateShopMenu(),
  dispatchEditShopMenu(),
  dispatchGetShop(),
  dispatchUpdateMailSenders(),
];

export default adminSagas;
